const backendOrigin = () =>
  (process.env.REACT_APP_API_URL || '').replace(/\/api\/v1$/, '') || window.location.origin;

/** 将相对路径（/uploads/...）转为完整 URL，http 开头的原样返回，其他相对路径原样返回 */
export const resolveUrl = (url?: string | null): string | undefined =>
  url ? (url.startsWith('/uploads/') ? `${backendOrigin()}${url}` : url) : undefined;
